const SPEAKABLE_WORD_PATTERN = /[A-Za-z]+(?:['’][A-Za-z]+)*(?:-[A-Za-z]+(?:['’][A-Za-z]+)*)*/g;

export const pronunciationTokenKey = (value) => String(value || '')
  .replace(/’/g, "'")
  .toLowerCase();

export const tokenizePronunciationSentence = (sentence) => {
  const text = String(sentence || '');
  const tokens = [];
  let cursor = 0;

  for (const match of text.matchAll(SPEAKABLE_WORD_PATTERN)) {
    const offset = match.index || 0;
    if (offset > cursor) {
      tokens.push({ text: text.slice(cursor, offset), speakable: false, key: '' });
    }
    tokens.push({
      text: match[0],
      speakable: true,
      key: pronunciationTokenKey(match[0]),
    });
    cursor = offset + match[0].length;
  }

  if (cursor < text.length) {
    tokens.push({ text: text.slice(cursor), speakable: false, key: '' });
  }
  return tokens;
};

export const collectPronunciationWords = (items) => {
  const words = [];
  const seen = new Set();
  const addText = (text) => {
    tokenizePronunciationSentence(text).forEach((token) => {
      if (!token.speakable || seen.has(token.key)) return;
      seen.add(token.key);
      words.push(token.text);
    });
  };

  // Target words are prepared first so the most useful audio wins the queue.
  (items || []).forEach((item) => addText(item?.word));
  (items || []).forEach((item) => addText(item?.pronunciation_sentence));
  return words;
};
